import { DateTime } from "luxon";
import { formatDate } from "../../formatters";
import { ArrowRightIcon } from "../../icons/ArrowRightIcon";
import { DateRangeIcon } from "../../icons/DateRangeIcon";
import { TimeIcon } from "../../icons/TimeIcon";
import { Text } from "../../typography";

type IncompletePermitInterval = {
	startDate?: string;
	startTime?: string;
	endDate?: string;
	endTime?: string;
	schedules?: unknown[];
};

type IncompleteTimePreviewProps = {
	permitIntervals: IncompletePermitInterval[];
	isInstant?: boolean;
	i18n: {
		startsNow: string;
		chooseDate: string;
		chooseTime: string;
		chooseStartDate: string;
		chooseStartTime: string;
		chooseExpiryDate: string;
		chooseExpiryTime: string;
	};
};

export const IncompleteTimePreview = ({ permitIntervals, isInstant = false, i18n }: IncompleteTimePreviewProps) => {
	const intervals =
		permitIntervals.length > 0
			? permitIntervals
			: [{ startDate: undefined, startTime: undefined, endDate: undefined, endTime: undefined }];

	return (
		<div className="space-y-2">
			{intervals.map((interval, index) => {
				const hasSchedule = interval.schedules && interval.schedules.length > 0;
				return (
					// biome-ignore lint/suspicious/noArrayIndexKey: safe index
					<div key={index}>
						<div className="flex items-start gap-2">
							<DateRangeIcon className="mt-[1px] size-4" />
							<div className="flex items-start gap-2">
								{isInstant ? (
									<div className="flex items-start">
										<Text size="sm" weight="bold">
											{i18n.startsNow}
										</Text>
									</div>
								) : (
									<div className="flex flex-col items-start">
										<Text size="sm" weight="bold">
											{interval.startDate ? (
												`${formatDate({
													date: DateTime.fromFormat(
														interval.startDate,
														"yyyy-MM-dd",
													).toJSDate(),
													formatType: "Abbreviated_Date",
												})}`
											) : (
												<span aria-label={i18n.chooseStartDate}>{i18n.chooseDate}</span>
											)}
										</Text>
										{!hasSchedule && (
											<div className="flex items-center gap-2 rounded-md bg-neutral-faded px-2 py-1">
												<TimeIcon className="size-3" />
												<Text size="xs">
													{interval.startTime ? (
														formatDate({
															date: DateTime.fromFormat(
																interval.startTime,
																"HH:mm:ss",
															).toJSDate(),
															formatType: "Abbreviated_Time",
														})
													) : (
														<span aria-label={i18n.chooseStartTime}>{i18n.chooseTime}</span>
													)}
												</Text>
											</div>
										)}
									</div>
								)}
								<ArrowRightIcon className="mt-[2px] size-4 shrink-0" />
								<div className="flex flex-col items-start">
									<Text size="sm" weight="bold">
										{interval.endDate ? (
											formatDate({
												date: DateTime.fromFormat(interval.endDate, "yyyy-MM-dd").toJSDate(),
												formatType: "Abbreviated_Date",
											})
										) : (
											<span aria-label={i18n.chooseExpiryDate}>{i18n.chooseDate}</span>
										)}
									</Text>
									{!hasSchedule && (
										<div className="flex items-center gap-2 rounded-md bg-neutral-faded px-2 py-1">
											<TimeIcon className="size-3" />
											<Text size="xs">
												{interval.endTime ? (
													formatDate({
														date: DateTime.fromFormat(
															interval.endTime,
															"HH:mm:ss",
														).toJSDate(),
														formatType: "Abbreviated_Time",
													})
												) : (
													<span aria-label={i18n.chooseExpiryTime}>{i18n.chooseTime}</span>
												)}
											</Text>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};
